import {
    CommitmentEntity,
    ObservationEntity,
} from '../../coaching-base/config';
import {
    CommitmentSummaryListItem,
    ObservationSummaryDto,
} from '../../coaching-base/general';
import { createAction } from '../../store.model';

import { CommitmentCategory } from './commitment-category.model';
import { ObservationCategory } from './observation-category.model';
import { StatusView } from './status-view.model';
import { TabRefId } from './tab-ref-id.model';

export enum ActionType {
    COACHING_DETAIL__P2__SELECT_METRIC = 'COACHING_DETAIL__P2__SELECT_METRIC',
    COACHING_DETAIL__P2__RELOAD = 'COACHING_DETAIL__P2__RELOAD',
    COACHING_DETAIL__P2__RELOAD_RESULT = 'COACHING_DETAIL__P2__RELOAD_RESULT',
    COACHING_DETAIL__P2__RELOAD_CANCEL = 'COACHING_DETAIL__P2__RELOAD_CANCEL',
    COACHING_DETAIL__P2__SET_ACTIVE = 'COACHING_DETAIL__P2__SET_ACTIVE',
    COACHING_DETAIL__P2__SET_STATUSES = 'COACHING_DETAIL__P2__SET_STATUSES',
    COACHING_DETAIL__P2__SET_CATEGORY_OPEN_STATE = 'COACHING_DETAIL__P2__SET_CATEGORY_OPEN_STATE',
    COACHING_DETAIL__P2__SET_CATEGORY_OPEN_STATE_FROM_CMT_FOR_OBSERVATIONS = 'COACHING_DETAIL__P2__SET_CATEGORY_OPEN_STATE_FROM_CMT_FOR_OBSERVATIONS',
}

export interface SelectMetric {
    metricId: number;
}

export const selectMetric = createAction<ActionType, SelectMetric>(
    ActionType.COACHING_DETAIL__P2__SELECT_METRIC,
);

/// ///////

export interface Reload {
    userId: number;
    authUserId: number;

    /** set to null to reload both */
    which?: TabRefId;

    /** for retaining isOpen state of categories */
    retainIsOpen?: boolean;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.COACHING_DETAIL__P2__RELOAD,
);

export interface ReloadResult extends Reload {
    commitments?: CommitmentSummaryListItem[];
    observations?: ObservationSummaryDto[];
    commitmentConfig?: CommitmentEntity;
    observationConfig?: ObservationEntity;
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.COACHING_DETAIL__P2__RELOAD_RESULT,
);

export interface ReloadCancel {
    /** set to null to cancel all combinations */
    which?: TabRefId;
}

export const reloadCancel = createAction<ActionType, ReloadCancel>(
    ActionType.COACHING_DETAIL__P2__RELOAD_CANCEL,
);

/// ///////

export interface SetActive {
    which?: TabRefId;
    id?: number | string;
}

export const setActive = createAction<ActionType, SetActive>(
    ActionType.COACHING_DETAIL__P2__SET_ACTIVE,
);

/// ///////

export interface SetStatuses {
    statuses: StatusView[];
}

export const setStatuses = createAction<ActionType, SetStatuses>(
    ActionType.COACHING_DETAIL__P2__SET_STATUSES,
);

/// ///////

export interface SetCategoryOpenState {
    category: CommitmentCategory | ObservationCategory;
    isOpen: boolean;
}

export const setCategoryOpenState = createAction<
    ActionType,
    SetCategoryOpenState
>(ActionType.COACHING_DETAIL__P2__SET_CATEGORY_OPEN_STATE);
export interface SetCategoryOpenStateForObservations {
    cmtIdentifier: string;
}

export const setCategoryOpenStateForObservations = createAction<
    ActionType,
    SetCategoryOpenStateForObservations
>(
    ActionType.COACHING_DETAIL__P2__SET_CATEGORY_OPEN_STATE_FROM_CMT_FOR_OBSERVATIONS,
);
